import request from '../utils/http'
// 学生列表
export function index (query) {
  return request({
    url: '/student/list',
    method: 'GET',
    params: query
  })
}
// 新增学生
export function save (query) {
  return request({
    url: '/student/save',
    method: 'POST',
    data: query
  })
}
// 编辑学生
export function edit (query) {
  return request({
    url: '/student/edit',
    method: 'GET',
    params: query
  })
}
// 更新学生
export function update (query) {
  return request({
    url: '/student/update',
    method: 'POST',
    data: query
  })
}
// 删除学生
export function del (query) {
  return request({
    url: '/student/delete',
    method: 'DELETE',
    data: query
  })
}
// 学生开关
export function show (query) {
  return request({
    url: '/student/show',
    method: 'POST',
    data: query
  })
}
// 学生激活
export function active (query) {
  return request({
    url: '/student/active',
    method: 'POST',
    data: query
  })
}
// 开关列表
export function modularList (query) {
  return request({
    url: '/modular/list',
    method: 'GET',
    params: query
  })
}
// 导出学生数据
export function studentExport (query) {
  return request({
    url: '/student/export',
    method: 'POST',
    responseType: 'blob',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/student.js